/** @fileoverview Shows the "App not found" message on a hosted app page. */

import AppNotFoundIllustration from '../components/illustrations/AppNotFoundIllustration';

type Props = {
  heading?: string;
  text?: string;
};

/** Explains that the app cannot be shown, by default because the address matches no app the person can open. */
export default function AppNotFoundView({
  heading = 'App not found',
  text = 'Check the address, or ask the person who shared it for the right link.',
}: Props) {
  return (
    <main className="flex min-h-screen flex-col items-center justify-center gap-3 p-6 text-center">
      <AppNotFoundIllustration />
      <h1 className="mt-2 text-base font-semibold">{heading}</h1>
      <p className="text-sm text-app-text-muted">{text}</p>
    </main>
  );
}
